import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './LandingPage.css';

import { HomePage }     from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { AboutPage }    from './pages/AboutPage';
import { ContactPage }  from './pages/ContactPage';

import { LandingHeader }     from './components/LandingHeader';
import { LandingNavigation } from './components/LandingNavigation';

export function LandingPage() {
  return (
    <div className="landing-page">
      <LandingHeader />
      <LandingNavigation />

      <main className="landing-content">
        <Routes>
          <Route path="/"          element={<HomePage />} />
          <Route path="/services"  element={<ServicesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/about"     element={<AboutPage />} />
          <Route path="/contact"   element={<ContactPage />} />
          <Route path="*"          element={<HomePage />} />
        </Routes>
      </main>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Uttar Labs</h4>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.6 }}>
              Nepal's AI & NLP solutions company — building intelligent language technology for government agencies and businesses.
            </p>
            <p style={{ color: '#64748b', fontSize: '0.8rem', marginTop: 8 }}>
              Built in Kathmandu · Nepal AI Policy 2082 Compliant
            </p>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="/services">Nepali NLP Engine</a></li>
              <li><a href="/services">Intelligent Chatbots</a></li>
              <li><a href="/services">Document Intelligence</a></li>
              <li><a href="/services">Translation APIs</a></li>
              <li><a href="/services">Speech Solutions</a></li>
              <li><a href="/services">AI Automation</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Solutions</h4>
            <ul>
              <li><a href="/solutions">Government & Public Sector</a></li>
              <li><a href="/solutions">Banking & Finance</a></li>
              <li><a href="/solutions">Healthcare</a></li>
              <li><a href="/solutions">Agriculture</a></li>
              <li><a href="/solutions">Education</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>📧 anzelix@gmail.com</p>
            <p style={{ color: '#94a3b8', fontSize: '0.875rem' }}>📍 Kathmandu, Nepal</p>
            <p style={{ color: '#94a3b8', fontSize: '0.875rem', marginTop: 8, lineHeight: 1.5 }}>
              Free 30-min consultation for any organization exploring AI.
            </p>
            <a
              href="/contact"
              style={{ display: 'inline-block', marginTop: 12, padding: '0.45rem 1rem', background: '#0891b2', color: 'white', borderRadius: 20, fontSize: '0.8rem', fontWeight: 600, textDecoration: 'none' }}
            >
              Schedule a Call
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Uttar Labs. AI & NLP Solutions for Nepal.</p>
        </div>
      </footer>
    </div>
  );
}
